import React from 'react';
import { getModelState } from 'client/data/luckdragon/model';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { CmsModel } from 'client/data/models/cms';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { parseContent } from 'client/data/cms/content';
import { handle404Error } from 'site-modules/shared/utils/errors';
import { getMeta } from 'site-modules/shared/utils/seo-helper';
import { getPressArticleContentPath, getPressLandingContentPath } from 'site-modules/editorial/utils/content-path';
import { getPressArticleBreadcrumbs } from 'site-modules/editorial/utils/breadcrumbs';
import { PressDecorator } from 'site-modules/editorial/pages/about/press/press-decorator';
import { PressArticle } from './press-article';

export const pageOptions = {
  name: 'other_about_us_press_release_article',
  category: 'other',
  preload: (store, props) => {
    const {
      match: {
        params: { articleId },
      },
    } = props;
    const preloader = new ModelPreloader(store);
    const articlePath = getPressArticleContentPath(articleId);

    preloader.resolve(`content["${articlePath}.withContent"]`, CmsModel);
    preloader.resolve(`content["${getPressLandingContentPath()}"]`, CmsModel);

    return preloader.load().then(modelState => {
      const article = modelState.get(`content["${articlePath}.withContent"]`, CmsModel);

      if (!(article && article.id)) {
        throw handle404Error({ errorMessage: `No content was found for ${articlePath}` });
      }

      return preloader.load();
    });
  },
  seo: (state, props) => {
    const {
      match: {
        params: { articleId },
      },
    } = props;
    const modelState = getModelState(state);
    const articlePath = getPressArticleContentPath(articleId);
    const content = parseContent(modelState.get(`content["${articlePath}.withContent"]`, CmsModel));

    return {
      ...getMeta(content),
      title: content.title,
      jsonld: [getBreadcrumbSchema(getPressArticleBreadcrumbs({ articleId, title: content.title }))],
    };
  },
  component: props => <PressArticle {...props} articleId={props.match.params.articleId} />,
  decorator: PressDecorator,
};

export default pageDefinition(pageOptions);
